export function hasSetupTransactionAuthentication() {
  return this.isUsingGoogleTwoFactor || this.hasTransactionPasswordEnabled;
}

export function hasSetupAllTransactionAuthentication() {
  return this.isUsingGoogleTwoFactor && this.hasTransactionPasswordEnabled;
}

export function isVerified() {
  return this.verifiedAt !== null;
}


// WEBPACK FOOTER //
// ./client/app/shared/security/security.util.js